import React from 'react';
import { indexOf, isObject, mergeWith, orderBy } from 'lodash';

import { PanelHeader } from 'js/components';
import { Card, CardBody } from 'reactstrap';
import { titleCase } from 'js/utils/string';
import { getSummaryMetrics } from 'js/utils/question-set';
import AssessmentSummary from './AssessmentSummary';
import AssessmentReviewHeader from './AssessmentReviewHeader';

function buildCategoryLookups(assessments, supplementalCategories) {
  const configCategories = (assessments ?? [])
    .map((a) => a?.config?.categories)
    .filter((x) => isObject(x))
    .reduce(
      (acc, categories) =>
        mergeWith(acc, categories, (obj, src) =>
          obj !== undefined ? obj : src
        ),
      {}
    );

  const allCategories = mergeWith(
    configCategories,
    supplementalCategories,
    (obj, src, key) =>
      obj !== undefined ? obj : { display_name: titleCase(key) }
  );

  const categoryMap = new Map(
    Object.entries(allCategories).sort(
      ([, a], [, b]) => (a?.ordinal ?? 0) - (b?.ordinal ?? 0)
    )
  );

  let ci = 0;
  categoryMap.forEach((value) => {
    value.palette = `palette-cat-${++ci}`;
  });

  return categoryMap;
}

const AssessmentReview = (props) => {
  const { assessments, team, teamId, assessmentKey, match } = props;
  const orderedAssessments = orderBy(assessments, ['inserted_at'], ['desc']);
  const name = orderedAssessments.length ? orderedAssessments[0].name : '';

  const collatedData = [];

  orderedAssessments.forEach((a) => {
    (a.question_sets || []).forEach((qs, i) => {
      const questionSet = (collatedData[i] = collatedData[i] || {
        name: qs.name,
        questions: [],
      });

      qs.questions.forEach((q, j) => {
        const question = (questionSet.questions[j] = questionSet.questions[
          j
        ] || {
          text: q.text,
          answers: q.answers,
          responses: [],
        });

        question.responses = [
          ...question.responses,
          ...q.responses.map((r) => ({
            assessmentId: a.id,
            value: indexOf(q.answers, (ans) => ans.id === r.answer_id),
            ...r,
          })),
        ];
      });
    });
  });

  const dataMap = getSummaryMetrics(orderedAssessments);
  const categoryLookups = buildCategoryLookups(
    orderedAssessments,
    dataMap.categories
  );
  const categoryColorMap = {};
  categoryLookups.forEach((value, key) => {
    categoryColorMap[key] = value.palette;
  });

  return (
    <div className="question-set-history live-assessment">
      <PanelHeader size="flex">
        <div className="panel-content">
          <AssessmentReviewHeader
            name={name}
            team={team}
            teamId={teamId}
            assessmentKey={assessmentKey}
            assessments={orderedAssessments}
            dataMap={dataMap}
            categoryLookups={categoryLookups}
            categoryColorMap={categoryColorMap}
          />
        </div>
      </PanelHeader>
      <div className="content">
        <Card>
          <CardBody>
            <div className="question-set-assessments">
              {orderedAssessments.map((a) => (
                <AssessmentSummary
                  key={a.id}
                  team={team}
                  assessment={a}
                  baseUrl={match.url}
                />
              ))}
            </div>
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default AssessmentReview;
